'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Level(_ref) {
  var title = _ref.title,
      _class = _ref._class,
      data = _ref.data,
      _getPosition = _ref.getPosition;

  return _react2.default.createElement(
    'div',
    { className: 'level-col ' + _class },
    _react2.default.createElement(
      'h2',
      null,
      title
    ),
    _react2.default.createElement(
      'div',
      { className: 'role-container' },
      data.map(function (_ref2, key) {
        var isActive = _ref2.isActive,
            jobs = _ref2.jobs;
        return _react2.default.createElement(_Column2.default, {
          key: key,
          isActive: isActive,
          jobs: jobs,
          getPosition: function getPosition(index, position) {
            _getPosition(key, index, position);
          }
        });
      })
    )
  );
}
exports.default = Level;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/components/Level.jsx
// module id = 1174
// module chunks = 0